export function AcademySvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/academy.svg'"></ng-include>`
    }
}